import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ManageDepartment = Loadable(lazy(() => import("./DepartmentList")));
const ManageDepartmentEdit = Loadable(lazy(() => import("./DepartmentAdd")));

const DepartmentRoutes = [
  { path: "/ems/department", element: <ManageDepartment /> },
  { path: "/ems/department/:mode/:id", element: <ManageDepartmentEdit /> },
];

export default DepartmentRoutes;
